import {Exclude, Expose, instanceToPlain, plainToInstance} from "class-transformer";
import * as t from "io-ts";
import {validateJSON, validateJSONNow} from "../web/validation";
import {Entity} from "./entity";

export const WaterGoPreferenceCodec = t.intersection([
  t.type({
    id: t.string,
    objectId: t.string,
    objectType: t.string,
  }),
  t.partial({
    gaugeAutoCalcEnabled: t.boolean,
    prePostTripEnabled: t.boolean,
    prepopulatePickupQuantity: t.boolean,
    shiftAuthorizationEnabled: t.boolean,
    showUserActivityOnly: t.boolean,
    createDttm: t.number,
    lastModifiedDttm: t.number,
  }),
]);

export const WaterGoPreferenceArrayCodec = t.array(
  WaterGoPreferenceCodec
);

export type WaterGoPreference = t.TypeOf<typeof WaterGoPreferenceCodec>;
export type WaterGoPreferenceArray = t.TypeOf<typeof WaterGoPreferenceArrayCodec>;

@Exclude()
export class WaterGoPreferenceEntity implements Entity {
  @Expose()
  id!: string;

  @Expose()
  objectId!: string;

  @Expose()
  objectType!: string;

  @Expose()
  gaugeAutoCalcEnabled?: boolean;

  @Expose()
  prePostTripEnabled?: boolean;

  @Expose()
  prepopulatePickupQuantity?: boolean;

  @Expose()
  shiftAuthorizationEnabled?: boolean;

  @Expose()
  showUserActivityOnly?: boolean;

  @Expose()
  createDttm?: number;

  @Expose()
  lastModifiedDttm?: number;

  readonly entityType = 'WATERGO_PREF';

  get displayName(): Readonly<string> {
    return this.id;
  }

  /**
   * Constructor for WaterGoPreferenceEntity. Recommend using the {@link create} method instead.
   * @hideconstructor
   */
  constructor() {
    // Empty constructor for 'class-transformer'
  }

  static from(value: WaterGoPreference): WaterGoPreferenceEntity {
    return plainToInstance(WaterGoPreferenceEntity, value, {
      excludeExtraneousValues: true,
    });
  }

  loadTypeValue(): Promise<WaterGoPreference> {
    const object = instanceToPlain(this, {
      excludeExtraneousValues: true,
    });
    return validateJSON(WaterGoPreferenceCodec, object);
  }

  asTypeValue(): WaterGoPreference {
    const object = instanceToPlain(this, {
      excludeExtraneousValues: true,
    });
    return validateJSONNow(WaterGoPreferenceCodec, object);
  }
}
